export const leave = {
  en: {
    entitlement: "Annual entitlement",
    certificate: "Medical certificate",
    viewCertificate: "View certificate",
    recordedNotDecided: "With the certificate attached this leave is recorded, not decided — there is nothing to wait for. Your direct manager and HR are notified.",
    annualLeave: "Annual leave",
    allRequests: "All leave requests",
    teamTitle: "Annual leave — everyone",
    teamNote: "Annual leave only. The other types are quotas tied to an event rather than balances that build up. Open a name for that person's full leave record — this table does not edit anything.",
    teamEmpty: "Nobody in your scope matches.",
    colEntitlement: "Entitlement",
    colAccrued: "Accrued",
    colTaken: "Taken",
    colPending: "Pending",
    colAvailable: "Available",
    colProjected: "After pending",
    absencesTitle: "Away now and next 14 days",
    absencesNote: "Names and dates only — the reason for leave stays between the employee and whoever approved it.",
    absencesEmpty: "Nobody is away in the next 14 days.",
    awayNow: "Away now",
    awaySoon: "Upcoming",
    noBalance: "No annual leave balance yet. This appears once your contract is active.",
    availableBalance: "Available to take",
    accruesDaily: "Leave accrues daily from your contract start date, so this figure grows a little every day. Sick, emergency and other leave are chosen when you file a request.",
    accrualExplained: "Leave accrues daily from your contract start date. You begin with nothing and earn the full annual entitlement across the year, so the accrued figure grows every day.",
    submitForTitle: "File leave for someone",
    editTitle: "Correct this request",
    editNote: "Fix what was entered wrongly. The dates, type and reason are checked again exactly as a new request would be.",
    editApprovedNote: "This request is approved and stays approved — the record is amended, not withdrawn. The balance is recomputed and the change is written to the audit trail. Leave that falls in a payroll run already approved or paid cannot be changed here; ask HR.",
    filedOnBehalfBy: "filed by {name}",
    submitForNote: "Use this when a member of staff cannot file the request themselves. They are told it was filed in their name, and somebody else has to approve it — you cannot decide a request you submitted.",
    submitForSubmit: "File request",
    balanceAvailable: "{days} available after pending requests",
    allowNegative: "Allow this to take the balance negative",
    adjustTitle: "Adjust a balance",
    adjustNote: "Records a correction against the balance, with a reason kept in the audit trail.",
    adjustKind: "Adjustment",
    adjustDays: "Days",
    adjustEffective: "Effective from",
    adjustSignNote: "Use a positive number to add days, a negative number to remove them.",
    deleteTitle: "Delete this leave request?",
    deleteBody: "{employee} — {type}, {from} to {to} ({days} days). The request is removed completely and the employee will no longer see it. This cannot be undone. Cancelling instead keeps the record and returns the days.",
    cancelApproved: "Cancel leave",
    cancelApprovedTitle: "Cancel leave that has been approved?",
    cancelApprovedBody: "This leave was granted, so the employee may already be counting on it. Cancelling returns the days to their balance and keeps the record — tell them.",
    withdrawTitle: "Withdraw this request?",
    withdrawBody: "The request is cancelled and the days return to the balance.",
    pendingOwn: "{count} of your requests are awaiting a decision.",
    title: "Leave",
    myLeave: "My leave",
    request: "Request leave",
    leaveType: "Leave type",
    balance: "Balance",
    available: "Available",
    pending: "Pending",
    projected: "After pending requests",
    projectedAvailable: "available after pending requests",
    accrued: "Accrued",
    consumed: "Taken",
    approve: "Approve",
    reject: "Reject",
    withdraw: "Withdraw",
    statusPending: "Pending",
    statusApproved: "Approved",
    statusRejected: "Rejected",
    statusCancelled: "Withdrawn",
    daysRequested: "Days requested",
    encashment: "Leave encashment",
    encashDays: "Days to encash",
    encashAsOf: "Value the balance to",
    encashAsOfHint: "The balance is earned up to this day. Set it to the last working day before unpaid leave, if the payout is being prepared early.",
    dailyRate: "Daily rate (full wage)",
    payout: "Payout amount",
    encash: "Record encashment",
    adjustBalance: "Adjust balance",
    noRequests: "No leave requests.",
    overBalanceWarning: "This request exceeds the available balance.",
    confirmUnpaidTitle: "Approve unpaid leave?",
    confirmUnpaidBody: "{employee} would be on unpaid leave for {days} days, from {from} to {to}. Payroll deducts a day of basic salary for each one, so this reduces their pay across every month it touches.",
  },
  ar: {
    entitlement: "الاستحقاق السنوي",
    certificate: "التقرير الطبي",
    viewCertificate: "عرض التقرير",
    recordedNotDecided: "بإرفاق التقرير تُسجَّل هذه الإجازة ولا تحتاج إلى بت — لا شيء تنتظره. يُبلَّغ مديرك المباشر والموارد البشرية.",
    annualLeave: "الإجازة السنوية",
    allRequests: "جميع طلبات الإجازة",
    teamTitle: "الإجازة السنوية — الجميع",
    teamNote: "الإجازة السنوية فقط. الأنواع الأخرى حصص مرتبطة بحدث وليست أرصدة تتراكم. افتح الاسم لعرض سجل الإجازات الكامل لذلك الموظف — هذا الجدول للعرض فقط.",
    teamEmpty: "لا يوجد من يطابق البحث ضمن نطاقك.",
    colEntitlement: "الاستحقاق",
    colAccrued: "المستحق",
    colTaken: "المستخدم",
    colPending: "قيد الانتظار",
    colAvailable: "المتاح",
    colProjected: "بعد المعلّق",
    absencesTitle: "الغياب حالياً وخلال 14 يوماً",
    absencesNote: "الأسماء والتواريخ فقط — سبب الإجازة يبقى بين الموظف ومن اعتمدها.",
    absencesEmpty: "لا يوجد غياب خلال الأربعة عشر يوماً القادمة.",
    awayNow: "غائب حالياً",
    awaySoon: "قادم",
    noBalance: "لا يوجد رصيد إجازة سنوية بعد. يظهر الرصيد بمجرد سريان العقد.",
    availableBalance: "الرصيد المتاح",
    accruesDaily: "تُحتسب الإجازة يومياً من تاريخ بداية العقد، لذا يزداد هذا الرصيد قليلاً كل يوم. وتُختار الإجازة المرضية والاضطرارية وغيرها عند تقديم الطلب.",
    accrualExplained: "تُحتسب الإجازة يومياً من تاريخ بداية العقد. تبدأ من صفر وتستحق كامل الرصيد السنوي على مدار السنة، لذا يزداد الرصيد المستحق كل يوم.",
    submitForTitle: "تسجيل إجازة نيابة عن موظف",
    editTitle: "تصحيح الطلب",
    editNote: "صحّح ما أُدخل خطأً. تُفحص التواريخ والنوع والسبب من جديد تماماً كطلب جديد.",
    editApprovedNote: "هذا الطلب معتمد ويبقى معتمداً — يُعدَّل السجل ولا يُسحب. يُعاد احتساب الرصيد ويُسجَّل التعديل في سجل التدقيق. أما الإجازة الواقعة ضمن مسير رواتب معتمد أو مدفوع فلا يمكن تعديلها هنا؛ راجع الموارد البشرية.",
    filedOnBehalfBy: "قدّمه {name}",
    submitForNote: "استخدم هذا عندما لا يتمكن الموظف من تقديم الطلب بنفسه. يُبلَّغ الموظف بأن الطلب قُدّم باسمه، ويتولى البت فيه شخص آخر — لا يمكنك البت في طلب قدّمته بنفسك.",
    submitForSubmit: "تسجيل الطلب",
    balanceAvailable: "{days} متاح بعد الطلبات المعلقة",
    allowNegative: "السماح بأن يصبح الرصيد بالسالب",
    adjustTitle: "تعديل رصيد",
    adjustNote: "يسجّل تصحيحاً على الرصيد مع حفظ السبب في سجل التدقيق.",
    adjustKind: "نوع التعديل",
    adjustDays: "عدد الأيام",
    adjustEffective: "ساري من",
    adjustSignNote: "استخدم رقماً موجباً للإضافة ورقماً سالباً للخصم.",
    deleteTitle: "حذف طلب الإجازة؟",
    deleteBody: "{employee} — {type}، من {from} إلى {to} ({days} يوماً). سيُحذف الطلب نهائياً ولن يظهر للموظف بعد ذلك. لا يمكن التراجع عن هذا الإجراء. أما الإلغاء فيحتفظ بالسجل ويعيد الأيام إلى الرصيد.",
    cancelApproved: "إلغاء الإجازة",
    cancelApprovedTitle: "إلغاء إجازة تم اعتمادها؟",
    cancelApprovedBody: "هذه الإجازة معتمدة وقد يكون الموظف يعتمد عليها. الإلغاء يعيد الأيام إلى رصيده ويحتفظ بالسجل — أبلغه بذلك.",
    withdrawTitle: "سحب هذا الطلب؟",
    withdrawBody: "سيتم إلغاء الطلب وتعود الأيام إلى الرصيد.",
    pendingOwn: "لديك {count} طلب بانتظار القرار.",
    title: "الإجازات",
    myLeave: "إجازاتي",
    request: "طلب إجازة",
    leaveType: "نوع الإجازة",
    balance: "الرصيد",
    available: "المتاح",
    pending: "قيد الانتظار",
    projected: "بعد الطلبات المعلقة",
    projectedAvailable: "متاح بعد الطلبات المعلقة",
    accrued: "المستحق",
    consumed: "المستخدم",
    approve: "اعتماد",
    reject: "رفض",
    withdraw: "سحب الطلب",
    statusPending: "قيد الانتظار",
    statusApproved: "معتمد",
    statusRejected: "مرفوض",
    statusCancelled: "مسحوب",
    daysRequested: "عدد الأيام",
    encashment: "بدل الإجازة",
    encashDays: "الأيام المراد صرفها",
    encashAsOf: "احسب الرصيد حتى تاريخ",
    encashAsOfHint: "الرصيد يُحسب حتى هذا اليوم. إذا كنت تصرف قبل الموعد، اجعله آخر يوم عمل قبل الإجازة بدون راتب.",
    dailyRate: "الأجر اليومي (الراتب الكامل)",
    payout: "المبلغ المستحق",
    encash: "تسجيل الصرف",
    adjustBalance: "تعديل الرصيد",
    noRequests: "لا توجد طلبات إجازة.",
    overBalanceWarning: "هذا الطلب يتجاوز الرصيد المتاح.",
    confirmUnpaidTitle: "اعتماد إجازة بدون راتب؟",
    confirmUnpaidBody: "سيكون {employee} في إجازة بدون راتب لمدة {days} يوماً، من {from} إلى {to}. يخصم النظام أجر يوم من الراتب الأساسي عن كل يوم، وبذلك ينخفض الراتب في كل شهر تشمله هذه الفترة.",
  },
} as const;
